
  // Set imprint color value
  function setValue(el) {
    $('.color-option input[type="radio"]').attr('name', '');
    $('.color-option input[type="radio"]').prop('checked', false).removeAttr('Selected');

    $(el).attr('name', 'properties[Imprint Color]');
    $(el).prop('checked', true).attr('Selected', 'Selected');
  }

  // Set maximum length based on selected style
  function setMaxLength(el) {
    $('.input-box-radio input[type="radio"]').attr('name', '').prop('checked', false);

    $(el).attr('name', 'properties[Color]').prop('checked', true);

    let value = $(el).val();
    let maximumLength = 1;

    if (['Style A3', 'Style A5', 'Style C3', 'Style D3'].includes(value)) {
      maximumLength = 3;
    }

    $('#initialsId')
      .val('')
      .attr('maxlength', maximumLength)
      .attr('style', value);
  }

  // Configure customization options on page load
  $(document).ready(function () {
    setTimeout(function () {
      $('.customize_variant .product-form__radio').removeAttr('checked');
      commentPopUp();
    }, 1000);
  });

  // Handle back/forward browser navigation
  window.addEventListener('pageshow', function (event) {
    const historyTraversal = event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2);
    if (historyTraversal) window.location.reload();
  });

  // Show/hide logo customization options
  if ($('.customize_variant.Debossing').length || $('.customize_variant.Full.Color').length) {
    $('.customize_variant.order-wth-logo').show();
    $('.customize_variant.Debossing, .customize_variant.Full.Color').hide();

    let price = '';
    let minimumQty = 0;

    if ($('.customize_variant.Debossing').length) {
      price = $('.customize_variant.Debossing').find('.variant_price').html();
      minimumQty = $('.customize_variant.Debossing').attr('minimumQty');
    } else if ($('.customize_variant.Full.Color').length) {
      price = $('.customize_variant.Full.Color').find('.variant_price').html();
      minimumQty = $('.customize_variant.Full.Color').attr('minimumQty');
    }

    $('.customize_variant.order-wth-logo').find('.variant_price').html(price);
    $('#logo-decsription').text('One-Time Setup Charge ( Minimum Order Of ' + minimumQty + ' )');
  } else {
    $('.customize_variant.order-wth-logo').hide();
  }

  // Show logo options and reposition sections
  function showLogoOptions() {
    const variantContainerHeight = $($('.customize_variant')[0]).innerHeight();
    const orderWithLogoHeight = $('.customize_variant.order-wth-logo').innerHeight();
    const relativeHeight = $('.customize_variant.order-wth-logo').offset().top - $('.variant_start').offset().top;

    $('.customize_variant.Debossing').css('top', relativeHeight + orderWithLogoHeight + 8);

    if ($('.customize_variant.Debossing').length) {
      $('.customize_variant.Full.Color').css('top', relativeHeight + orderWithLogoHeight + variantContainerHeight - 7);
    } else {
      $('.customize_variant.Full.Color').css('top', relativeHeight + orderWithLogoHeight);
    }

    $('.customize_variant.Debossing, .customize_variant.Full.Color').show();
    $('.order-wth-logo').css('margin-bottom', '115px');

    $('input[value="Blank"], input[value="Personalization"]').prop('checked', false);
    
  }

  // Comment out inner HTML for popup elements
  function commentPopUp() {
    ['#debossing', '#fullcolor', '#personalize'].forEach(id => {
      let html = $(id).html();
      if (!html.includes('<!--commentStart')) {
        $(id).html(`<!--commentStart${html}commentEnd-->`);
      }
    });
  }

  // Handle quantity and personalization popup logic
  function updateQuantity(minQty, name) {
    commentPopUp();

    switch (name) {
      case 'Personalization':
        let personalizeHtml = $('#personalize').html();
        if (personalizeHtml.startsWith('<!--commentStart')) {
          personalizeHtml = personalizeHtml.substring(16, personalizeHtml.length - 14);
        }
         $('#order-wth-logo').prop('checked', false); 
         
          $('.customize_variant.Debossing, .customize_variant.Full.Color').hide();
          $('.order-wth-logo').css('margin-bottom', '0px');
        
        $('#personalize').html(personalizeHtml);

        $('input[value="Personalization"]').prop('checked', true);
        
        $('.personalize_btn label input').first().attr('name', 'properties[Color]').prop('checked', true);
        $('.box-with-color div label input').first().attr('name', 'properties[Imprint Color]').prop('checked', true);

        $('.halo-popup4').toggleClass('is-show');
        $('.personalize-wrap').toggleClass('is-overlay');

        setMaxLength($('input[name="properties[Color]"]'));

        $('#ClosePersonalize').on('click', function () {
          $('.halo-popup4').removeClass('is-show');
          $('.personalize-wrap').removeClass('is-overlay');
        });
        break;

      case 'Debossing':
        let debossHtml = $('#debossing').html();
        if (debossHtml.startsWith('<!--commentStart')) {
          debossHtml = debossHtml.substring(16, debossHtml.length - 14);
        }
        $('#debossing').html(debossHtml);

        $('.box-with-color.line-item-property__radio div input').first()
          .attr('name', 'properties[Imprint Color]')
          .prop('checked', true);

        $('.halo-popup2').toggleClass('is-show');
        $('.deboss_wrap').toggleClass('deboss-show');

        $('#Closedeboss').on('click', function () {
          $('.halo-popup2').removeClass('is-show');
          $('.deboss_wrap').removeClass('deboss-show');
        });
        break;

      case 'Full Color':
        let fullColorHtml = $('#fullcolor').html();
        if (fullColorHtml.startsWith('<!--commentStart')) {
          fullColorHtml = fullColorHtml.substring(16, fullColorHtml.length - 14);
        }
        $('#fullcolor').html(fullColorHtml);

        $('.halo-popup3').toggleClass('is-show');
        $('.full_wrap').toggleClass('full-show');

        $('#Closecolor').on('click', function () {
          $('.halo-popup3').removeClass('is-show');
          $('.full_wrap').removeClass('full-show');
        });
        break;

      case 'Blank':
      case 'Personalization':
        $('.customize_variant.Debossing, .customize_variant.Full.Color').hide();
        $('.order-wth-logo').css('margin-bottom', '0px');
        $('#order-wth-logo').prop('checked', false);
        break;
    }

    $('input[name="quantity"]').attr({ min: minQty, value: minQty });
    $('input[type="number"]').val(minQty);
    $('#product-add-to-cart').removeAttr('disabled');
  }

  // Enable or disable minQty validation on keyup
  $(function () {
    function setOnKeyUp(enable) {
      const target = $('.orderwithlogoinput');
      if (enable) {
        target.attr('onkeyup', 'validateMinQty(this);');
      } else {
        target.removeAttr('onkeyup');
      }
    }

    $('input[name="IMPRINT METHOD"], #order-wth-logo').on('click', function () {
      setOnKeyUp($(this).val() !== 'Blank');
    });

    setOnKeyUp(false);
  });

  // Validate quantity input against min
  function validateMinQty(el) {
    setTimeout(() => {
      const $el = $(el);
      const minQty = parseInt($el.attr('min'));
      const currentVal = parseInt($el.val());

      if (currentVal < minQty) {
        $el.val(minQty);
        console.log("min Quantity");
      } else {
        $el.val(currentVal);
        console.log("Valid Quantity");
      }
    }, 2000);
  }

  // Enable add to cart
  function select_invent() {
    $('#product-add-to-cart').removeAttr('disabled');
    
    
  }

  // Fallback if product can't be added
  $('.product-form__buttons').on('click', function () {
    if ($('#product-add-to-cart').is(":disabled")) {
      $('.customize_variant .product-form__radio').prop('checked', true);
    }
  });

